module.exports = __webpack_public_path__ + "media/apps/gif-ios-7-firstframe-995677ba.jpg";